import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";

const PostHogPageView = () => {
  const location = useLocation();

  useEffect(() => {
    // Track pageview når location endres
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      path: location.pathname,
    });
  }, [location]);

  return null;
};

export default PostHogPageView;